module.exports = __webpack_public_path__ + "img/Feature-8.d2a4112.svg";